// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { RiderSupportAreaId } from './RiderSupportAreaId'
import { RiderSupportAreaNavigation } from './RiderSupportAreaNavigation'
import { RiderSupportAreaRoutes } from './RiderSupportAreaRoutes'

const LazyRiderSupportComponent = lazy(() => import('./RiderSupportArea'))

const RiderSupportComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyRiderSupportComponent />
  </SuspenseLoadingWrapper>
)

export const RiderSupportArea = {
  id: RiderSupportAreaId,
  requiredRight: BoumRight.AREA_RIDER_SUPPORT,
  NavigationComponent: RiderSupportAreaNavigation,
  route: {
    path: RiderSupportAreaRoutes.route,
    component: RiderSupportComponent,
  },
}
